<template>
  <AllegroJsonForm
    title="Allegro - Dodaj konto"
    crumbLabel="Dodaj konto"
    submitAction="createAllegroAccount"
    submitGetter="getAllegroAccountCreateData"
    backRoute="/allegro/accounts"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroAccountPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroAccountCreate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroAccountPermissionsConst.add,
      fields: [
        { key: "name", label: "Nazwa konta", required: true },
        { key: "email", label: "E-mail", type: "email", required: true },
      ],
    };
  },
};
</script>
